module.exports = __webpack_public_path__ + "images/[9]5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[9]5.jpeg
// module id = 40
// module chunks = 0